import {equals, get, pipe} from '@logistics-frontend/utils'

import {
  ActionShowContentSections,
  ContentSection,
  DeliveryActionPayload,
  Payload,
  PayloadAction,
} from 'src/api/cargo-c2c'

const isDeliveryActionPayload = (action?: Payload): action is DeliveryActionPayload =>
  pipe(action, get('type'), equals('action-payload'))

const isActionShowContentSections = (action?: PayloadAction): action is ActionShowContentSections =>
  pipe(action, get('type'), equals('show_content_sections'))

export function getContentSections(action?: Payload): ContentSection[] | void {
  if (isDeliveryActionPayload(action) && isActionShowContentSections(action.action)) {
    return action.action.content_sections
  }
}
